const s = {
  name: "TargetArrow",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,11.4C0.7,14,0,16.9,0,20c0,11,9,20,20,20s20-9,20-20C40,9,31,0,20,0c-3.1,0-6,0.7-8.6,2l-2-2H5v5H0v4.4
			L2,11.4z M12.9,3.5C15.1,2.5,17.5,2,20,2c9.9,0,18,8.1,18,18s-8.1,18-18,18S2,29.9,2,20c0-2.5,0.5-4.9,1.5-7.1L5.6,15h1.3
			C6.3,16.6,6,18.2,6,20c0,7.7,6.3,14,14,14s14-6.3,14-14S27.7,6,20,6c-1.8,0-3.4,0.3-5,0.9V5.6L12.9,3.5z M9.1,15h4.5l0.1,0.1
			C12.6,16.4,12,18.2,12,20c0,4.4,3.6,8,8,8s8-3.6,8-8s-3.6-8-8-8c-1.8,0-3.6,0.6-4.9,1.7L15,13.6V9.1C16.5,8.4,18.2,8,20,8
			c6.6,0,12,5.4,12,12s-5.4,12-12,12S8,26.6,8,20C8,18.2,8.4,16.5,9.1,15z M15.1,16.5l4.2,4.2l1.4-1.4l-4.2-4.2
			c1-0.7,2.2-1.1,3.5-1.1c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6C14,18.7,14.4,17.5,15.1,16.5z M2,7h3.6l6,6H6.4L2,8.6V7z M13,6.4
			v5.2l-6-6V2h1.6L13,6.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as TargetArrow
};
